"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumberInput = exports.KEYTYPE = exports.KEY = void 0;
/**
 * Formats a phone number string by removing any non-digit characters and applying a standard U.S. format.
 * - If the input is falsy, it's returned as is.
 *
 * @param inputText - The phone number string, possibly containing non-digit characters.
 * @param keyCode
 * @param cursor.
 * @param cursorEnd.
 * @returns The formatted phone number string.
 */
exports.KEY = {
    BACKSPACE: 8,
    DEL: 46,
    LEFT: 37,
    RIGHT: 39,
    TAB: 9,
};
exports.KEYTYPE = {
    ENTER: "ENTER",
};
const formatPhoneNumberInput = (inputText, keyCode, cursor, cursorEnd) => {
    if (!inputText)
        return inputText;
    let finalStr = inputText;
    if ((keyCode === exports.KEY.DEL || keyCode === exports.KEY.BACKSPACE) &&
        cursor === cursorEnd) {
        if (cursor === 5 || cursor === 6) {
            finalStr = inputText.replace(/[^\d]/g, "");
            finalStr = finalStr.slice(0, 2) + finalStr.slice(3);
        }
        else if (cursor === 10 || cursor === 11 || cursor === 12) {
            finalStr = inputText.replace(/[^\d]/g, "");
            finalStr = finalStr.slice(0, 5) + finalStr.slice(6);
        }
    }
    return finalStr;
};
exports.formatPhoneNumberInput = formatPhoneNumberInput;
